import type { BranchKey } from '@festina-life/api'
import { RawRadioGroup } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'
import { useState } from 'react'

import { useConfiguredLayers } from '../../../../uiModels/api/metaModel/useConfiguredLayers'
import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { DownloadBulkConfiguration } from './DownloadBulkConfiguration'
import { DownloadLayerConfiguration } from './DownloadLayerConfiguration'

const exportModes = ['layer', 'bulk'] as const
type ExportMode = (typeof exportModes)[number]

type Props = {
  branchKey: BranchKey
}

export const DownloadConfigurationButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  const [exportMode, setExportMode] = useState<ExportMode>('layer')
  const configuredLayers = useConfiguredLayers()
  const exportModeLabelTranslations: Record<ExportMode, string> = {
    layer: translate('branchesTree.export.mode.layerLabel'),
    bulk: translate('branchesTree.export.mode.bulkLabel'),
  }
  const exportModeDescriptionTranslations: Record<ExportMode, string> = {
    layer: translate('branchesTree.export.mode.layerDescription'),
    bulk: translate('branchesTree.export.mode.bulkDescription'),
  }

  const doesBranchContainConfiguration = configuredLayers.length > 0

  return (
    <Popover>
      <PopoverButton as="div">
        <OperationsLoadedButton
          startIcon="ArrowDownTray"
          disabled={!doesBranchContainConfiguration}
        >
          {translate('branchDetailsPanel.tabs.manage.downloadBranchPackage')}
        </OperationsLoadedButton>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }}>
        <RawRadioGroup
          options={exportModes}
          onChange={setExportMode}
          value={exportMode}
          renderFn={(value) => exportModeLabelTranslations[value]}
        />
        <div className="flex flex-col gap-y-2">
          <p className="my-1">
            {exportModeDescriptionTranslations[exportMode]}
          </p>
          {exportMode === 'layer' ? (
            <DownloadLayerConfiguration branchKey={branchKey} />
          ) : (
            <DownloadBulkConfiguration branchKey={branchKey} />
          )}
        </div>
      </ActionsMenuPanel>
    </Popover>
  )
}
